import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

/**
 * Informational cancel page only. No state mutation. User can return to
 * the event and try again.
 */
export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-4 py-12" data-testid="payment-cancel-page">
      <div className="w-full max-w-lg bg-[#0A0A0A] border border-[#1A1A1A] rounded-sm p-8 text-center">
        <div className="mx-auto w-14 h-14 rounded-full bg-[#221111] border border-[#5f1f1f] flex items-center justify-center mb-5">
          <XCircle className="w-7 h-7 text-[#F87171]" />
        </div>
        <h1 className="text-2xl font-bold text-[#EAE7E1] mb-2 tracking-tight" data-testid="payment-cancel-heading">
          Payment was canceled
        </h1>
        <p className="text-[#AFAFAF] text-sm mb-8 leading-relaxed" data-testid="payment-cancel-message">
          You can return to the event and try again. Nothing was charged.
        </p>

        <div className="flex flex-col sm:flex-row gap-3">
          <Button
            onClick={() => navigate(-1)}
            className="flex-1 bg-gradient-to-r from-[#8C6B1F] via-[#D4AF37] to-[#F2D27A] hover:opacity-90 text-[#050505] rounded-sm px-6 py-3 font-bold"
            data-testid="payment-cancel-back-button"
          >
            Back to Event
          </Button>
          <Button
            onClick={() => navigate('/')}
            variant="outline"
            className="flex-1 border-[#1A1A1A] text-[#AFAFAF] hover:text-[#EAE7E1] hover:bg-[#1A1A1A] rounded-sm px-6 py-3"
            data-testid="payment-cancel-home-button"
          >
            Go Home
          </Button>
        </div>
      </div>
    </div>
  );
}
